export const NAVBAR_HEIGHT_EVENT = 'navbar-change-event';

export const SIDEBAR_OPEN_EVENT = 'sidebar-change-event';
